import {
  addProductToMyWishlistRequested,
  createMyWishlistRequested,
  deleteMyWishlistRequested,
  deleteProductFromMyWishlistRequested,
  getMyWishlistsRequested,
  updateMyWishlistRequested,
  updateProductQuantityFromMyWishlistRequested
} from '@spa/lib/store/wishlists/wishlistsSlice';
import { fork, takeEvery } from 'typed-redux-saga';
import addProductToMyWishlistSaga from '@spa/lib/store/sagas/wishlist/addProductToMyWishlistSaga';
import createMyWishlistSaga from '@spa/lib/store/sagas/wishlist/createMyWishlistSaga';
import deleteMyWishlistSaga from '@spa/lib/store/sagas/wishlist/deleteMyWishlistSaga';
import deleteProductFromMyWishlistSaga from '@spa/lib/store/sagas/wishlist/deleteProductFromMyWishlistSaga';
import getMyWishlistsSaga from './getMyWishlistsSaga';
import { takeLatest } from 'typed-redux-saga';
import updateMyWishlistSaga from '@spa/lib/store/sagas/wishlist/updateMyWishlistSaga';
import updateProductQuantityFromMyWishlistSaga from '@spa/lib/store/sagas/wishlist/updateProductQuantityFromMyWishlistSaga';
import watchAndNotifyCurrentWishlistChanges from '@spa/lib/store/sagas/wishlist/watchAndNotifyCurrentWishlistChanges';

function* wishlistSaga(): Generator {
  yield* fork(watchAndNotifyCurrentWishlistChanges);
  yield* takeLatest(getMyWishlistsRequested.type, getMyWishlistsSaga);
  yield* takeEvery(addProductToMyWishlistRequested.type, addProductToMyWishlistSaga);
  yield* takeEvery(createMyWishlistRequested.type, createMyWishlistSaga);
  yield* takeEvery(deleteMyWishlistRequested.type, deleteMyWishlistSaga);
  yield* takeEvery(deleteProductFromMyWishlistRequested.type, deleteProductFromMyWishlistSaga);
  yield* takeEvery(updateMyWishlistRequested.type, updateMyWishlistSaga);
  yield* takeEvery(
    updateProductQuantityFromMyWishlistRequested.type,
    updateProductQuantityFromMyWishlistSaga
  );
}

export default wishlistSaga;
